import styled from 'styled-components'

const RheostatContainer = styled.div`
  height: 39px;
  position: relative;

  .rheostat,
  .handleContainer {
    position: relative;
  }

  .handleContainer {
    position: relative;
    width: calc(100% - 16px);
  }

  .DefaultBackground,
  .DefaultProgressBar_progressBar {
    height: 4px;
    position: absolute;
    top: 6px;
  }

  .DefaultBackground {
    background-color: ${props => props.theme.colors.gray300};
    width: 100%;
  }

  .DefaultProgressBar_progressBar {
    background-color: ${props => props.theme.colors.primary};
  }

  .DefaultHandle_handle {
    z-index: 1;
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1px solid ${props => props.theme.colors.gray600};
    background-color: ${props => props.theme.colors.gray300};
  }

  .Values {
    position: absolute;
    bottom: 0;
  }

  .Values:first-child {
    left: 0;
  }

  .Values:last-child {
    right: 0;
  }
`

export default RheostatContainer
